module.exports = __webpack_public_path__ + "img/Orientacion.aa1c6fdd.png";